// The URL decides the language: /maschinen is German, /it/maschinen Italian, /en/maschinen English.
// Every language is prerendered separately (scripts/prerender.js), so search engines index each one.

export const LANGUAGES = ['de', 'it', 'en']
export const DEFAULT_LANGUAGE = 'de'

const STORAGE_KEY = 'language'

function languageOf(pathname) {
  const match = pathname.match(/^\/(it|en)(?=\/|$)/)
  return match ? match[1] : DEFAULT_LANGUAGE
}

export const language = typeof window !== 'undefined' ? languageOf(window.location.pathname) : DEFAULT_LANGUAGE

// Prefix of all router paths in the current language, e.g. "/it"
export const basename = language === DEFAULT_LANGUAGE ? '' : '/' + language

// Same page in another language; path is without prefix, e.g. ("it", "/maschinen") -> "/it/maschinen"
export function localizedPath(lang, path) {
  return lang === DEFAULT_LANGUAGE ? path : '/' + lang + path
}

// Language picked in the menu, remembered for the redirect below
export function rememberLanguage(lang) {
  try {
    localStorage.setItem(STORAGE_KEY, lang)
  } catch (e) { }
}

// German URLs (e.g. from a Google result) redirect to the language picked last in the menu or,
// if none was picked yet, to Italian for Italian browsers. Crawlers have neither and stay put.
// Returns true if the page is being redirected.
export function redirectToPreferredLanguage() {
  if (language !== DEFAULT_LANGUAGE) return false
  let preferred = null
  try {
    preferred = localStorage.getItem(STORAGE_KEY)
  } catch (e) { }
  if (!preferred && (navigator.language || '').toLowerCase().startsWith('it')) {
    preferred = 'it'
  }
  if (!LANGUAGES.includes(preferred) || preferred === DEFAULT_LANGUAGE) return false
  const { pathname, search, hash } = window.location
  window.location.replace(localizedPath(preferred, pathname) + search + hash)
  return true
}
